
const reviews = [
    {
      id: 1,
      name: 'Naveen Yadav',
      image:
        'https://lh3.googleusercontent.com/a-/AFdZucqTNwyS02LASp7mA0T_p_0yfEioZwGKMjI1RaUlYQ=w60-h60-p-rp-mo-br100',
      text:
        "Well environment and students are also good in nature, best hostel in cleanliness and also for study.",
    },
    {
      id: 2,
      name: 'Chandra Bhanu Prakash',
      image:
        'https://lh3.googleusercontent.com/a-/AFdZucpw0lA97SnZycft1LqHqWf0UJ66SsyKCQEOgmlv=w60-h60-p-rp-mo-br100',
      text:
        'A place which I want in my memory!',
    },
    {
      id: 3,
      name: 'Saurabh Y',
      image:
        'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ7ZqaKg8J9PSSNGfbFzLhotNqRA6kgqbyCrCD1k0l5abHMp_HnlXQNyOD94OInxV7LLDI&usqp=CAU',
      text:
        'Decent place to live here, rented room also available, there are many temples in the nearby area. Overall good place.',
    },
    {
      id: 4,
      name: 'Vaibhav Pandey',
      image:
      'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ7ZqaKg8J9PSSNGfbFzLhotNqRA6kgqbyCrCD1k0l5abHMp_HnlXQNyOD94OInxV7LLDI&usqp=CAU',
      text:
        'The nature of owner is truly awesome for me.!🤗',
    }
  ];
  
  export default reviews;